import { AppBar, Toolbar, Button, Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Link as RouterLink } from "react-router-dom";
import { useContext } from "react";
import { LanguageContext } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext"; // + AJOUT

export default function NavBar() {
  const { translate } = useContext(LanguageContext);
  const { currentUser } = useAuth(); // + AJOUT
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <AppBar
      position="static"
      elevation={0}
      sx={{
        py: 2,
        bgcolor: "background.paper",
        color: "text.primary",
        borderBottom: 1,
        borderColor: "divider",
      }}
    >
      <Toolbar sx={{ justifyContent: "space-between" }}>
        <Typography
          component={RouterLink}
          to="/"
          variant="h6"
          sx={{ textDecoration: "none", color: "inherit", fontWeight: 700 }}
        >
          {translate("Brand")}
        </Typography>

        <Box>
          <Button
            component={RouterLink}
            to="/aboutus"
            sx={{ textTransform: "none", color: "text.primary", mx: 1 }}
          >
            {translate("NavOffer")}
          </Button>
          <Button
            component={RouterLink}
            to="/pricing"
            sx={{ textTransform: "none", color: "text.primary", mx: 1 }}
          >
            {translate("Pricing")}
          </Button>

          {currentUser ? (
            <Button
              component={RouterLink}
              to="/app" // ← destination “Mes tickets” (adapte si besoin)
              variant="contained"
              color="primary"
              sx={{
                textTransform: "none",
                ml: 2,
                ...(isDark && { color: "primary.contrastText" }),
              }}
            >
              {translate("MyTickets")}
            </Button>
          ) : (
            <Button
              component={RouterLink}
              to="/login"
              variant={isDark ? "contained" : "outlined"}
              color="primary"
              sx={{
                textTransform: "none",
                ml: 2,
                ...(isDark
                  ? { color: "primary.contrastText" }
                  : {
                      color: "text.primary",
                      borderColor: "divider",
                      "&:hover": {
                        borderColor: "primary.main",
                        bgcolor: "action.hover",
                      },
                    }),
              }}
            >
              {translate("SignIn")}
            </Button>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
}
